export const getBusinessPalette = (businessId) => {
  if (businessId === 1 || businessId === 2 || businessId === 14 || businessId === 15 || businessId === 16) {
    return {
      overviewItemBg: '#EAF4FF',
      serviceNameColor: '#4A90E2',
      buttonBg: '#8c8c8c',
      buttonHoverBg: '#514e4c',

      datePickerSelectedDayBg: '#A8D8FF',
      datePickerSelectedDayHoverBg: '#8CCBFF',
      datePickerTodayBorder: '#4A90E2',
      datePickerDayHoverBg: '#DFF0FF',

      timeSlotSelectedBorder: '#A8D8FF',
      timeSlotSelectedBg: '#DFF0FF',
      timeSlotSelectedHoverBg: '#CBE8FF',

      dateBoxBg: '#F4FAFF',
      dateBoxBorder: '#CFE7FF',

      formContainerBg: '#F4FAFF',
      formContainerBorder: '#CFE7FF',
      formTitleColor: '#4A90E2',
      linkHoverColor: '#4A90E2',

      dialogContentBg: '#F4FAFF',
      dialogBorderColor: '#CFE7FF',
      cancelButtonColor: '#4A90E2',
      cancelButtonHoverBg: '#E3F2FF',
      proceedButtonBg: '#7FAEE6',
      proceedButtonHoverBg: '#5E92D6',

      categoryHeaderBg: '#DFF0FF',
      categoryHeaderHoverBg: '#CBE8FF',
      categoryHeaderActiveBg: '#B8DFFF',
      categoryHeaderBorderHover: '#4A90E2',

      serviceItemSelectedBg: '#EAF4FF',
      serviceItemBorder: '#D6EAFE',
      serviceItemSelectedBorder: '#A8D8FF',

      expandIconBg: '#CBE8FF',
      expandIconExpandedBg: '#A8D8FF',

      staffItemSelectedBg: '#EAF4FF',
      staffItemBorder: '#D6EAFE',
      staffItemSelectedBorder: '#A8D8FF',
    };
  }

  return {
    overviewItemBg: '#FFF2F4',
    serviceNameColor: '#D32F2F',
    buttonBg: '#8c8c8c',
    buttonHoverBg: '#514e4c',

    datePickerSelectedDayBg: '#FF4C4C',
    datePickerSelectedDayHoverBg: '#FF2B2B',
    datePickerTodayBorder: '#FF4C4C',
    datePickerDayHoverBg: '#FFECEC',

    timeSlotSelectedBorder: '#FFC0CB',
    timeSlotSelectedBg: '#FFC0CB',
    timeSlotSelectedHoverBg: '#FF9AA2',

    dateBoxBg: '#FFF8F9',
    dateBoxBorder: '#FFD7D7',

    formContainerBg: '#FFF2F4',
    formContainerBorder: '#FFD7D7',
    formTitleColor: 'black',
    linkHoverColor: 'blue',

    dialogContentBg: '#f9f9f9',
    dialogBorderColor: '#e0e0e0',
    cancelButtonColor: '#f44336',
    cancelButtonHoverBg: '#ffe6e6',
    proceedButtonBg: '#4caf50',
    proceedButtonHoverBg: '#388e3c',

    categoryHeaderBg: '#ffd2d9',
    categoryHeaderHoverBg: '#ffc4cf',
    categoryHeaderActiveBg: '#ffb2bf',
    categoryHeaderBorderHover: '#C2185B',

    serviceItemSelectedBg: '#ffe0e5',
    serviceItemBorder: '#ffe0e5',
    serviceItemSelectedBorder: '#ffe0e5',

    expandIconBg: '#FFD7D7',
    expandIconExpandedBg: '#FFB3B3',

    staffItemSelectedBg: '#ffe0e5',
    staffItemBorder: '#ffe0e5',
    staffItemSelectedBorder: '#ffe0e5',
  };
};